import { ChipOption } from '@marageti/z4-lib';
import { TripMatchStatus } from '@marageti/z4-sdk/lib/travel';
import { canceledStatusesValue } from '../../../hooks/use-trip-match-search';

export interface CountryObject {
  country: string
}

type Option = {
  title: string;
  value: string;
};

export const sortByOptions: Option[] = [
  { title: 'New to Old', value: 'createdAt' },
  { title: 'Total Budget', value: 'budget' },
  { title: 'Departure Date (New to Old)', value: 'departureDateDesc' },
  { title: 'Departure Date (Old to New)', value: 'departureDateAsc' },
];

export const sortByValues: { [key: string]: { field: string; order: string } } = {
  createdAt: { field: 'createdAt', order: 'desc' },
  budget: { field: 'budget', order: 'desc' },
  departureDateDesc: { field: 'departureDate', order: 'desc' },
  departureDateAsc: { field: 'departureDate', order: 'asc' },
};

export const statusChipOptions: ChipOption[] = [
  { key: 0, label: 'New', value: TripMatchStatus.MatchPending },
  { key: 1, label: 'Accepted', value: TripMatchStatus.MatchAccepted },
  { key: 2, label: 'Active', value: TripMatchStatus.MatchActive },
  { key: 3, label: 'Sold', value: TripMatchStatus.MatchSold },
  { key: 4, label: 'Partner Declined', value: TripMatchStatus.MatchPartnerDeclined },
  { key: 5, label: 'Postponed', value: TripMatchStatus.MatchPostponed },
  { key: 6, label: 'Inactive', value: TripMatchStatus.MatchInactive },
  { key: 7, label: 'Canceled', value: canceledStatusesValue },
];

export const refineSoldChipOptionss: ChipOption[] = [
  { key: 0, label: 'Pre Travel', value: 'preTravel' },
  { key: 1, label: 'In Country', value: 'inCountry' },
  { key: 2, label: 'Request Review', value: 'requestReview' },
];
